export const COMMENTING_FEEDBACK = 'MO:CollaborationSidebar:CommentingFeedback';
export const UNREAD_COMMENTS = 'MO:CollaborationSidebar:UnreadComments';
export const FLOATING_SIDEBAR_ALL = 'MO:CollaborationSidebar:FloatingSidebar:All';
export const COMPOSABLE_DRAG_AREA = 'MO:CollaborationSidebar:ComposableDragArea';
export const LIVE_COMMENTS = 'MO:CollaborationSidebar:LiveComments';
export const GET_LINK_TO_COMMENT = 'MO:CollaborationSidebar:GetLinkToComment';